import addressTypes from './address-types';
import fieldTypes from './contact-fields-types';

const ADDRESS_FIELDS = addressTypes.map(type => {
  return [
    { header: type.name },
    { divider: true },
    {
      value: {
        addressTypeValue: `${type.value}_street_address_1`,
        addressValue: 'street_address_1',
        addressType: type.value,
        type: fieldTypes.ADDRESS_FIELD,
      },
      name: `${type.value} Street Address 1`,
      type: fieldTypes.ADDRESS_FIELD,
      addressType: type.value,
      addressValue: 'street_address_1',
    },
    {
      value: {
        addressTypeValue: `${type.value}_street_address_2`,
        addressValue: 'street_address_2',
        addressType: type.value,
        type: fieldTypes.ADDRESS_FIELD,
      },
      name: `${type.value} Street Address 2`,
      type: fieldTypes.ADDRESS_FIELD,
      addressType: type.value,
      addressValue: 'street_address_2',
    },
    {
      value: {
        addressTypeValue: `${type.value}_zip`,
        addressValue: 'zip',
        addressType: type.value,
        type: fieldTypes.ADDRESS_FIELD,
      },
      name: `${type.value} Zip code`,
      type: fieldTypes.ADDRESS_FIELD,
      addressType: type.value,
      addressValue: 'zip',
    },
    {
      value: {
        addressTypeValue: `${type.value}_city`,
        addressValue: 'city',
        addressType: type.value,
        type: fieldTypes.ADDRESS_FIELD,
      },
      name: `${type.value} City`,
      type: fieldTypes.ADDRESS_FIELD,
      addressType: type.value,
      addressValue: 'city',
    },
    {
      value: {
        addressTypeValue: `${type.value}_state`,
        addressValue: 'state',
        addressType: type.value,
        type: fieldTypes.ADDRESS_FIELD,
      },
      name: `${type.value} State`,
      type: fieldTypes.ADDRESS_FIELD,
      addressType: type.value,
      addressValue: 'state',
    },
  ];
});

export default ADDRESS_FIELDS;
